var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_856",
    "data-name": "Group 856",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 18.403,
    viewBox: "0 0 30 18.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M0-384H30v18.4H0Z",
    transform: "translate(0 384)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M-297.875-19.167q-6.875,0-13.751,0c-.221,0-.3.046-.3.287q.01,7.953,0,15.907c0,.239.077.288.3.288q13.751-.008,27.5,0c.308,0,.309,0,.309-.318q0-7.918,0-15.835c0-.319,0-.319-.331-.319h-13.727m15.006,17.438c-.1,0-.191-.013-.286-.013h-29.428c-.1,0-.191.008-.286.013v-18.4c.1,0,.191.013.286.013h29.428c.1,0,.191-.008.286-.013Z",
    transform: "translate(312.869 20.132)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309",
    transform: "translate(18.706 6.137)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M-73.29-65.995l-.115-1.293h-.064l-.585,1.293Zm-3.689,2.807L-76.1-65q.992-2.042,1.983-4.086a.326.326,0,0,1,.342-.227q.693.021,1.388,0c.192-.006.246.073.265.242q.241,2.128.491,4.254c.062.529.129,1.058.2,1.633h-.611c-.255,0-.512-.017-.766,0s-.3-.078-.3-.3c-.014-.389-.058-.778-.091-1.2-.451,0-.888,0-1.324.005-.042,0-.1.07-.122.12-.18.382-.357.765-.525,1.153a.3.3,0,0,1-.324.214c-.476-.013-.952,0-1.482,0",
    transform: "translate(76.979 69.317)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310",
    transform: "translate(5.771 6.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M-23.078-24.254l1.11.682.035-.05-2.306-1.832c.14-.007.22-.015.3-.015.7,0,1.405.009,2.108-.006.217,0,.285.065.3.275.09,1.089.193,2.178.293,3.267a.527.527,0,0,0,.1.277c.083-.176.168-.351.25-.527.482-1.033.961-2.068,1.448-3.1.036-.075.125-.175.192-.177.54-.014,1.081-.008,1.666-.008-.122.244-.224.456-.331.665q-1.33,2.583-2.659,5.168a.459.459,0,0,1-.5.3c-.39-.025-.782-.01-1.173,0-.123,0-.185-.029-.2-.166-.213-1.549-.432-3.1-.648-4.646a.4.4,0,0,1,.021-.1",
    transform: "translate(24.24 25.475)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(14.483 6.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M0-114.846l.506-1.232c.473.124.919.258,1.374.35a1.009,1.009,0,0,0,.512-.072.416.416,0,0,0,.116-.775c-.262-.193-.548-.353-.828-.522a1.753,1.753,0,0,1-.045-3.071,3.072,3.072,0,0,1,2.977-.146.248.248,0,0,1,.115.21c-.137.405-.3.8-.432,1.166a10.117,10.117,0,0,0-1.091-.244,1.179,1.179,0,0,0-.593.126.291.291,0,0,0-.063.533,8.7,8.7,0,0,0,.8.523,1.779,1.779,0,0,1,1.031,1.625,1.933,1.933,0,0,1-1.453,1.888,3.338,3.338,0,0,1-2.794-.265A1.41,1.41,0,0,1,0-114.846",
    transform: "translate(0 120.627)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312",
    transform: "translate(12.061 6.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M0-121.748c.141-.743.272-1.439.4-2.136.237-1.247.478-2.493.705-3.741.034-.186.1-.257.289-.251.437.013.875,0,1.352,0-.076.4-.145.763-.214,1.128-.3,1.584-.6,3.168-.892,4.753-.033.182-.1.254-.291.247-.437-.015-.875,0-1.353,0",
    transform: "translate(0 127.876)",
    fill: "#ec812d",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisa);
export default __webpack_public_path__ + "static/media/icon-visa.686fbda6fd0b44cbbb15ca1a14b3bc32.svg";
export { ForwardRef as ReactComponent };